import React from "react";
import styles from "./AddButton.module.scss";
import add from "../../images/circle-plus.svg";

type OwnProps = {
  onClick: () => void;
  title: string;
  id?: string;
};

const AddButton = ({ title, id, onClick }: OwnProps): JSX.Element => (
  <div className={styles.AddButton}>
    {id !== "disablebutton" ? (
      <button id={id} onClick={() => onClick()}>
        <img alt="Add button" src={add} /> {title}
      </button>
    ) : (
      <button id={id}>
        <img alt="Add button" className={styles.disableImg} src={add} />{" "}
        <span className={styles.disableText}>{title}</span>
      </button>
    )}
  </div>
);

export default AddButton;
